import type { RowData } from "@tanstack/react-table";
import type { RecordColumnDef } from "../column-types";

export function resolveColumnId<TData extends RowData>(
  column: RecordColumnDef<TData, unknown>,
  index: number,
): string {
  if (column.id) return column.id;
  if ("accessorKey" in column && typeof column.accessorKey === "string") {
    return column.accessorKey;
  }
  return `column-${index}`;
}

export function resolveColumnIds<TData extends RowData>(
  columns: Array<RecordColumnDef<TData, unknown>>,
): string[] {
  return columns.map(resolveColumnId);
}
